var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"brand-logo2"},[(!_vm.isCollapsed)?_c('b-img',{attrs:{"src":_vm.appLogoImage,"alt":"logo"}}):_c('b-img',{attrs:{"src":_vm.appLogoIcon,"alt":"logo"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }